import { type AxiosRequestConfig } from 'axios'

const getEventById = (id?: string): AxiosRequestConfig => {
  return {
    method: 'GET',
    url: `/event/${id}`
  }
}

export { getEventById }
